import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { InputText } from 'primereact/inputtext';
import { Ripple } from 'primereact/ripple';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useAuth } from '../hooks/auth-provider';
import { useYupValidationResolver } from '../utilities/useYupValidationResolver';

const schema = yup.object().shape({
    email: yup.string().required('Email je obaveyno polje').email('Neispravan email'),
    password: yup.string().required('Lozinka je obaveyno polje').min(6, 'Lozinka mora biti najmanje 6 karaktera')
});

export const Login = () => {
    const { login, getAuthUser } = useAuth();
    const [loginUrl, setLoginUrl] = useState(null);

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm({
        resolver: useYupValidationResolver(schema)
    });

    const navigate = useNavigate();

    useEffect(() => {
        getAuthUser()
            .then((data) => {
                console.log('url', data);
                setLoginUrl(data.url);
            })
            .catch((error) => console.error(error));
    }, []);

    const handleLogin = async (data) => {
        login(data.email, data.password)
            .then(() => {
                // navigate('/', { key: Date.now() });
                // redirect to /
                window.location.href = '/';
            })
            .catch((error) => {
                setError('login', {
                    type: 'manual',
                    message: 'Neispravno korisničko ime ili lozinka. Pokušajte ponovo.'
                });
            });
    };

    return (
        <div className="login-page px-4  md:px-6 lg:px-8 flex align-items-center justify-content-center">
            <div className="w-full lg:w-6 p-4 lg:p-7 ">
                <Link to={'/'}>
                    <div className="login-header w-full flex align-items-center justify-content-center mb-2 px-2 pt-2">
                        <div className="login-header__logo ">
                            <img src="assets/logo_full.svg" alt="logo" width={120} />
                        </div>
                    </div>
                </Link>
                <div className="flex justify-content-center align-items-center mb-7  text-center ">
                    <div className="text-2xl  text-center  font-medium text-900">Uloguj se u ecOil</div>
                </div>

                {loginUrl != null && (
                    <a href={loginUrl}>
                        <div className="flex justify-content-center">
                            <button className="p-ripple ml-2 w-6 font-medium border-1 surface-border surface-100 py-3 px-2 p-component hover:surface-200 active:surface-300 text-900 cursor-pointer transition-colors transition-duration-150 inline-flex align-items-center justify-content-center">
                                <i className="pi pi-google text-pink-500 mr-2"></i>
                                <span>Uloguj se putem Googla</span>
                                <Ripple />
                            </button>
                        </div>
                    </a>
                )}

                <Divider align="center" className="my-4">
                    <span className="text-600 font-normal text-sm">ILI</span>
                </Divider>
                <form onSubmit={handleSubmit(handleLogin)}>
                    {/* ... */}
                    <label htmlFor="email" className="block text-900 font-medium mb-2">
                        Email
                    </label>
                    <InputText id="email" type="text" placeholder="Email address" {...register('email')} className="w-full mb-3 p-3" />
                    {errors.email && <p>{errors.email.message}</p>}
                    {/* ... */}
                    <label htmlFor="password" className="block text-900 font-medium mb-2">
                        Lozinka
                    </label>
                    <InputText id="password" type="password" placeholder="Password" {...register('password')} className="w-full mb-3 p-3" />
                    {errors.password && <p>{errors.password.message}</p>}
                    {/* ... */}
                    <div className="text-pink-500  font-medium mb-4 block">{errors.login && <p>{errors.login.message}</p>}</div>
                    <Button label="Ulaz" type="submit" className="w-full py-3 font-medium" />
                </form>
                <div className="mt-4 text-center text-900 font-medium">
                    <Link to="/register" className="text-xl text-green-500 hover:text-green-700 cursor-pointer transition-colors transition-duration-150">
                        Nemate nalog?
                    </Link>
                </div>
            </div>
        </div>
    );
};
